// Signup and onboarding behaviour. Every control works without this file
// (chips are native checkboxes and radios); this adds the conveniences
// from the design: show/hide password, live trait count and "+N more",
// shared hours copied to per-day inputs, the photo drop zone, the about
// prompts and counter, and the rate hint.
document.addEventListener('DOMContentLoaded', function () {
  // Account step: show/hide password
  document.querySelectorAll('[data-password-toggle]').forEach(function (button) {
    var input = document.getElementById(button.getAttribute('data-password-toggle'));
    if (!input) return;
    button.addEventListener('click', function () {
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      button.textContent = show ? 'Hide' : 'Show';
      button.setAttribute('aria-pressed', show ? 'true' : 'false');
    });
  });

  // Account step: focus the first invalid field
  var invalid = document.querySelector('.su-input--invalid');
  if (invalid) invalid.focus();

  // Traits: live "N selected" and the per-group "+N more" expander
  var traitForm = document.querySelector('[data-trait-picker]');
  if (traitForm) {
    var counter = document.querySelector('[data-trait-count]');
    var updateCount = function () {
      if (!counter) return;
      var n = traitForm.querySelectorAll('input[name="trait_ids[]"]:checked').length;
      counter.textContent = n + ' selected';
    };
    traitForm.addEventListener('change', updateCount);
    updateCount();

    traitForm.querySelectorAll('[data-more]').forEach(function (button) {
      var group = button.closest('[data-trait-group]');
      var hidden = group.querySelectorAll('.su-chip-wrap--hidden');
      var count = hidden.length;
      if (count === 0) { button.remove(); return; }
      button.querySelector('[data-more-label]').textContent = '+' + count + ' more';
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        hidden.forEach(function (wrap) { wrap.classList.toggle('su-chip-wrap--hidden', expanded); });
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        button.querySelector('[data-more-label]').textContent = expanded ? '+' + count + ' more' : 'Show fewer';
      });
    });
  }

  // Availability: shared hours fill every per-day row until it is customised
  var hours = document.querySelector('[data-hours]');
  if (hours) {
    var startAll = hours.querySelector('[data-hours-start]');
    var endAll = hours.querySelector('[data-hours-end]');
    var rows = Array.from(hours.querySelectorAll('[data-perday-row]'));
    var panel = hours.querySelector('[data-perday]');
    var disclosure = hours.querySelector('[data-perday-toggle]');

    var syncRows = function () {
      rows.forEach(function (row) {
        if (row.dataset.custom === 'true') return;
        row.querySelector('[data-perday-start]').value = startAll.value;
        row.querySelector('[data-perday-end]').value = endAll.value;
      });
    };
    var showSelectedRows = function () {
      rows.forEach(function (row) {
        var day = hours.querySelector('input[name="' + row.dataset.perdayRow + '_available"]');
        row.hidden = !(day && day.checked);
      });
    };

    startAll.addEventListener('change', syncRows);
    endAll.addEventListener('change', syncRows);
    rows.forEach(function (row) {
      row.addEventListener('change', function () { row.dataset.custom = 'true'; });
    });
    hours.querySelectorAll('input[name$="_available"]').forEach(function (day) {
      day.addEventListener('change', showSelectedRows);
    });
    if (disclosure && panel) {
      disclosure.addEventListener('click', function () {
        var open = disclosure.getAttribute('aria-expanded') === 'true';
        disclosure.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    }
    showSelectedRows();
    if (hours.dataset.hoursFresh === 'true') syncRows();
  }

  // Photo: drop zone with live preview
  var zone = document.querySelector('[data-dropzone]');
  if (zone) {
    var fileInput = document.getElementById(zone.getAttribute('data-dropzone'));
    var prompt = document.querySelector('[data-photo-prompt]');
    var chooseButton = document.querySelector('[data-photo-choose]');
    var removeButton = document.querySelector('[data-photo-remove]');
    var hadPhoto = zone.classList.contains('su-dropzone--filled');
    var originalImage = zone.style.backgroundImage;

    var render = function (state) {
      zone.classList.toggle('su-dropzone--drag', state === 'drag');
      if (state === 'drag') { prompt.textContent = 'Drop to upload'; return; }
      var filled = zone.classList.contains('su-dropzone--filled');
      prompt.textContent = filled ? 'Looking good' : 'Drop a photo here, or browse';
      chooseButton.textContent = filled ? 'Replace photo' : 'Choose a photo';
      if (removeButton) removeButton.hidden = !(filled && fileInput.files.length > 0);
    };
    var accept = function (file) {
      if (!file || !file.type.match(/^image\//) || file.size > 10 * 1024 * 1024) {
        prompt.textContent = 'Please choose a JPG or PNG under 10 MB.';
        return;
      }
      zone.style.backgroundImage = 'url("' + URL.createObjectURL(file) + '")';
      zone.classList.add('su-dropzone--filled');
      render();
    };

    zone.addEventListener('click', function () { fileInput.click(); });
    zone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    chooseButton.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () { accept(fileInput.files[0]); });
    zone.addEventListener('dragover', function (e) { e.preventDefault(); render('drag'); });
    zone.addEventListener('dragleave', function () { render(); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      var file = e.dataTransfer.files[0];
      if (file) {
        try { fileInput.files = e.dataTransfer.files; } catch (err) { /* older browsers */ }
        accept(file);
      } else {
        render();
      }
    });
    if (removeButton) {
      removeButton.addEventListener('click', function () {
        fileInput.value = '';
        zone.style.backgroundImage = originalImage;
        zone.classList.toggle('su-dropzone--filled', hadPhoto);
        render();
      });
    }
    render();
  }

  // About: prompt chips and character counter
  var about = document.querySelector('[data-about]');
  if (about) {
    var counterEl = document.querySelector('[data-about-count]');
    var max = parseInt(about.getAttribute('maxlength') || '600', 10);
    var count = function () { if (counterEl) counterEl.textContent = about.value.length + ' / ' + max; };
    about.addEventListener('input', count);
    count();
    document.querySelectorAll('[data-prompt]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var current = about.value.replace(/\s*$/, '');
        about.value = (current ? current + ' ' : '') + chip.getAttribute('data-prompt');
        about.focus();
        count();
      });
    });
  }

  // Rate: hint sentence relative to the typical range, when one is known
  var rateHint = document.querySelector('[data-rate-hint]');
  var rateInput = document.getElementById('hourly_rate');
  if (rateHint && rateInput) {
    var low = parseInt(rateHint.dataset.low, 10);
    var high = parseInt(rateHint.dataset.high, 10);
    var sentence = rateHint.querySelector('[data-rate-sentence]');
    var update = function () {
      var r = parseInt(rateInput.value, 10);
      if (isNaN(r)) { sentence.textContent = ''; return; }
      sentence.textContent = r < low ? 'You could ask for more — families here expect at least $' + low + '.'
        : r > high ? 'Above typical; specialised experience justifies it.'
        : 'Right in the typical range.';
    };
    rateInput.addEventListener('input', update);
    update();
  }
});
